import { Component } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-metodologia',
  templateUrl: './metodologia.component.html',
  styleUrl: './metodologia.component.css'
})
export class MetodologiaComponent {

  public texto = []

  constructor(
    public dataService: DataService,
    public translate: TranslateService,
  ){
    this.getText();
  }
  /**
   * Metodo que obtiene el texto diciendo que es encabezado y que es texto
   */
  getText(){
    this.texto.push({
      text: 'ESQUEMA METODOLÓGICO DE EVALUACIÓN DE CLIMA LABORAL',
      type: 'header',
    },{
      text: `En este punto se debe detallar el esquema metodológico de aplicación de la encuesta de clima laboral, sustentándola con elementos técnicos (referencias), la estructura de las dimensiones, la integración de una serie de indicadores a cada una de estas y la asignación de escala de calificación.`,
      type: 'text',
    },{
      text: `La idea de este tablero introductorio es que pueda servir de base conceptual para la organización y sienta el respaldo de un estudio muy bien definido.`,
      type: 'text',
    },{
      text: `Idealmente la información se presentaría en un esquema de roll down para irlo leyendo.`,
      type: 'text',
    },{
      text: `Esta explicación metodológica igualmente puede ir integrada (o no) al informe final.`,
      type: 'text',
    },{
      text: `SIMBOLOGÍA`,
      type: 'header'
    },{
      text: `Incluir toda la simbología que se incluye en los tableros`,
      type: 'text'
    });
  }
}
